export * from "./passwordValidationPattern"